__turbopack_context__.v({
  "fullHeightHero": "Page-module-scss-module__UAJHXq__fullHeightHero",
  "page": "Page-module-scss-module__UAJHXq__page",
});
